import React, { useContext, useEffect, useRef, useState } from 'react'
import { useForm,Controller } from "react-hook-form";
import "../../../PaiementCmcStep/_Step.scss";
import { FirstUpperCase } from '../../../../services/Helpers/fonctions';
import { ElementContext } from '../../../../services/Context/Context';
import { pays } from '../../../../utils/pays_fr';
import { GoPlusCircle } from 'react-icons/go';
import AddChassisModal from '../../ModalForm/AddChassis/AddChassisModal';
import ColorSelect from '../../../CouleurSelect/CouleurSelect';
import OtherColors from '../../ModalForm/Step/OtherColors';
// import { couleurs } from '../../../../utils/couleurs';
import "./StepFour.scss";
const StepTwo = ({ activeStep,setActiveStep,nextStep,prevStep,setPaiement, paiement,handleInput }) => {
  const { register,handleSubmit,reset,formState: { errors },setError,setValue,control } = useForm({
    defaultValues: {
      modele: paiement.infovehicule.modele || "",
      numeroChassis: (paiement.typeDemandeur === "concessionnaire" || paiement.typeDemandeur === "constructeur") 
        ? paiement.infovehicule.numeroChassis 
        : paiement.infovehicule.numeroChassis[0] || [],
      categorie: paiement.infovehicule.categorie || "",
      marque: paiement.infovehicule.marque || "",
      ptac: paiement.infovehicule.ptac || 0,
      dateMiseCirculation: paiement.infovehicule.dateMiseCirculation || "0",
      paysProvenance: paiement.infovehicule.paysProvenance || "",
      paysDestination: paiement.infovehicule.paysDestination || "",
      poidsAVide: paiement.infovehicule.poidsAVide || 0,
      puissanceFiscale: paiement.infovehicule.puissanceFiscale || 0,
      chargeUtile: paiement.infovehicule.chargeUtile || 0,
      poidsTotalRoulant: paiement.infovehicule.poidsTotalRoulant || 0
    },
    mode: "onChange" // Validate on change
  });
  const [typeAutorisations,setTypeAutorisations ] = useState(["transit","circulation temporaire"]);  
  const { elementsData } = useContext(ElementContext); 
  const { categories,marques,modeles } = elementsData || { categories: [],marques:[],modeles:[]};
  const [selectModeles,setSelectedModeles ] = useState([]);
  const [showModal,setShowModal] = useState(false);
  const [showOtherColor,setShowOtherColor] = useState(false);
  const inputRef = useRef(null);
  const [numeroChassis, setNumeroChassis] = useState(
    paiement.infovehicule.numeroChassis?.[0] || ""
  );

  //console.log(modeles)
  const handleNext = () => {
    // Clear all errors first
    Object.keys(errors).forEach((key) => setError(key, null));
    
    let isValid = true;
  
    if (paiement.typeDemandeur === "concessionnaire" || paiement.typeDemandeur === "constructeur") {
      if (paiement.infovehicule.numeroChassis.length === 0) {
        setError("infovehicule.numeroChassis", { 
          type: "required", 
          message: "Le numéro de chassis est obligatoire" 
        });
        isValid = false;
      }
    }
  
    if (!paiement.infovehicule.couleur) {
      setError("infovehicule.couleur", { 
        type: "required", 
        message: "La couleur est obligatoire" 
      });
      isValid = false;
    }
  
    if (isValid) {
      nextStep();
    }
  };
  useEffect(() => {
     setSelectedModeles(modeles.filter((p) => p.marque_id == paiement.infovehicule.marque));
  },[paiement.infovehicule.marque]) ;

   //console.log(paiement);

  const ChassisComponent = ({ setShowModal }) => {
    
    const addChassis = () => {
      setShowModal(true);
      setError("infovehicule.numeroChassis","");
    }
 
    return (
      <>
      
         <label className='obligatoire'>Numéro de chassis
           {(paiement.typeDemandeur === "concessionnaire" || paiement.typeDemandeur === "constructeur") ? (
             <>
             <input
                type="hidden"
                {...register("infovehicule.numeroChassis", {
                  validate: {
                    notEmpty: () => paiement.infovehicule.numeroChassis.length > 0 || "Vous devez ajouter au moins un numéro de chassis"
                  }
                })}
                value={ paiement.infovehicule?.numeroChassis.length > 0 ?  paiement.infovehicule?.numeroChassis?.join(","):""} // This ensures the validation triggers
             />
             <input 
                 onFocus={addChassis}
                 readOnly={true}
                 value={paiement.infovehicule.numeroChassis ? paiement.infovehicule.numeroChassis.join(", "):""}
                 id='numeroChassis'
              />
             </>
             
            ):
            <input 
              type='text'
              name='numeroChassis'
              className='chassis-input'
              placeholder="Numéro de chassis du véhicule"
              
              value={paiement.infovehicule.numeroChassis?.[0] || ""}
              {...register("numeroChassis", {
                required: "Le numéro de chassis est obligatoire",
                minLength: {
                  value: 1,
                  message: "Le numéro de chassis doit contenir au moins 1 caractère"
                },
                maxLength: {
                  value: 17,
                  message: "Le numéro de chassis ne doit pas dépasser 17 caractères"
                },
                pattern: {
                  value: /^[A-HJ-NPR-Z0-9]{1,17}$/i, // Standard VIN pattern
                  message: "Format de chassis invalide"
                }
              })}
              onChange={(e) => {
               if( e.target.value.length <= 17 ) {
                  setPaiement(prev => ({
                    ...prev,
                    infovehicule: {
                      ...prev.infovehicule,
                      numeroChassis: [e.target.value] // Store as array with single element
                    }
                  }));
                 setValue("infovehicule.numeroChassis", [e.target.value]);
               }
              }}
              />
            } 
           {errors?.numeroChassis && (
            <>
              {["required", "minLength", "maxLength", "pattern", "validate", "notEmpty"].map((errorType) => (
                errors?.numeroChassis?.type === errorType && (
                  <span key={errorType} className="error-msg">
                    {errors?.numeroChassis?.message}
                  </span>
                )
              ))}
            </>
          )}
         </label>
      </>
         
    )
  }
 
  return (
    <div className='step-component step-two'> 
      {showModal && <AddChassisModal 
                        isOpen={showModal}
                        setIsOpen={setShowModal} 
                        paiement={paiement}
                        setPaiement={setPaiement}
                    />}
      {showOtherColor && <OtherColors 
                           isOpen={showOtherColor}
                           setIsOpen={setShowOtherColor} 
                           handleInput={handleInput}
                           paiement={paiement}
                    />}
      <form onSubmit={handleSubmit(handleNext)}>
        <div className='input-group'>
           <label className='obligatoire'>Categorie de Vehicule
               <select
                 name='categorie'
                 value={paiement?.infovehicule?.categorie || ""}
                 {...register("categorie", {
                    onChange: (e) => {
                       handleInput(e);
                    },
                   validate: (value) => value !== "" || "Ce champ est obligatoire"
                 })}
                 >
                 <option value="">---</option>
                 {categories?.map((cat) => (
                  <option value={cat.categorie_id} key={cat.categorie_id}>
                    {cat.nomCategorie}
                  </option>
                ))}
               </select> 
               {errors?.categorie && (
                 <span className="error-msg">{errors.categorie.message}</span>
              )} 
           </label>
           <label className='obligatoire'>Marque
             <select
              value={paiement.infovehicule.marque}
              {...register("marque", {
                onChange: (e) => {
                   handleInput(e);
                },
                   validate: (value) => value !== "" || "Veuillez selection la marque.",
             })}
             >
            <option value="">---</option>
            {marques.length > 0 && marques.map((marque) => (
               <option value={marque.id} key={marque.id}>{ marque.title }</option>
              ))
               }
             </select>
              {errors.marque && (
                  <>
                   {["validate"].map((errorType) => (
                       errors.infovehicule.marque?.type === errorType && (
                       <span key={errorType} className="error-msg">
                           {errors.marque.message}
                       </span>
                      )
                    ))}
                 </>
              )}
          </label>
        </div>
        <div className='input-group'>
          <label className='obligatoire'>Modèle
          
             <select
               value={paiement.infovehicule.modele}
               name='modele'
               {...register("modele", {
                 onChange: (e) => {
                    handleInput(e); 
                },
               validate: (value) => value !== "" || "Veuillez selectionner la modèle.",
             })}
             
             >
               <option value="">---</option>
               { selectModeles.length > 0 && selectModeles.map((modele) => (
                <option value={modele.id} key={modele.id}>{ modele.title }</option>
               ))}
             </select>
             {errors.infovehicule?.modele && (
                  <>
                   {["validate"].map((errorType) => (
                       errors.infovehicule.modele?.type === errorType && (
                       <span key={errorType} className="error-msg">
                           {errors.modele.message}
                       </span>
                      )
                    ))}
                 </>
              )}
          </label>
      
         { ChassisComponent ({setShowModal})}
        </div>
        <div className='input-group'>
          <label className='obligatoire'>PTAC
             <input type='numeric'
               name='ptac'
               value={paiement.infovehicule.ptac || 0}
               {...register("ptac", {
                required: "Le PTAC est obligatoire",
                min: {
                  value: 1,
                  message: "Le PTAC ne peut pas être inférieur à 1 kg"
                },
                // max: {
                //   value: 10000,
                //   message: "Le PTAC ne peut pas dépasser 10 000 kg"
                // },
                onChange: (e) => handleInput(e),
              
              })}
               step="50"
             />
             {errors?.ptac && (
                <span className="error-msg">
                    {errors.ptac.message}
                </span>
             )}
          </label>
          <label className='obligatoire'>PV en KG
             <input type='numeric'
               name='poidsAVide'
               value={paiement.infovehicule.poidsAVide || 0}
               {...register("poidsAVide", {
                required: "Le poids à vide est obligatoire",
                min: {
                  value: 1,
                  message: "Le Poids à vide ne peut pas être inférieur à 1 kg"
                },
                onChange: (e) => handleInput(e),
              })}
             />
             {errors?.poidsAVide && (
                <span className="error-msg">
                    {errors.poidsAVide.message}
                </span>
               )}
          </label>
        </div>
        <div className='input-group'>
          <label className='obligatoire'>Puissance fiscale (CV)
            <input type='numeric'
              name='puissanceFiscale'
              value={paiement.infovehicule?.puissanceFiscale || 0}
              {...register("puissanceFiscale", {
                required: "La puissance fiscale est obligatoire",
                onChange: (e) => handleInput(e),
                validate: (value) => 
                  (value % 1 === 0 && value > 0) || "La puissance fiscale doit être un multiple de 1" // Validation custom
              })}
            />
            {errors?.puissanceFiscale && (
                <span className="error-msg">
                    {errors.puissanceFiscale.message}
                </span>
               )}
          </label>
          <label className='obligatoire'>Charge Utile (KG)
            <input type='numeric'
              name='chargeUtile'
              value={paiement.infovehicule?.chargeUtile || 0}
              {...register("chargeUtile", {
                required: "La charge utile est obligatoire",
                min: {
                  value: 1,
                  message: "La charge utile ne peut pas être inférieure à 1"
                },
                // max: {
                //   value: 1000,
                //   message: "La charge utile ne peut pas dépasser 1000"
                // },
                onChange: (e) => handleInput(e),
               // Validation custom
               })}
              />
              {errors.chargeUtile && (
                <span className="error-msg">
                    {errors.chargeUtile.message}
                </span>
               )}
            </label> 
        </div>
       <div className='input-group'>
        <label>Poids Total Roulant ( PTRA )
           <input type='numeric'
            name='poidsTotalRoulant'
            value={paiement.infovehicule.poidsTotalRoulant || 0}
            {...register("poidsTotalRoulant", {
              required: "Le poids total roulant est obligatoire",
              onChange: (e) => handleInput(e),
              min: {
                value: 1,
                message: "Le PTRA ne peut pas être inférieur à 1 kg"
              },
              // max: {
              //   value: 10000,
              //   message: "Le PTRA ne peut pas dépasser 10 000 kg"
              // },
            })}
          />
           {errors?.poidsTotalRoulant && (
                <span className="error-msg">
                    {errors.poidsTotalRoulant.message}
                </span>
               )}
          </label> 
          <label className='obligatoire'>Couleur
            <Controller
                name="infovehicule.couleur"
                control={control}
                rules={{
                  validate: value => value !== "" || "La couleur est obligatoire."
                }}
                render={({ field, fieldState }) => (
                  <ColorSelect
                    onChange={(value) => {
                      field.onChange(value);
                      setShowOtherColor(value === "autre");
                      setPaiement(prev => ({
                        ...prev,
                        infovehicule: {
                          ...prev.infovehicule,
                          couleur: value
                        }
                      }));
                    }}
                    value={paiement.infovehicule.couleur}
                    setShowOtherColor={setShowOtherColor}
                    error={fieldState.error}
                  />
                )}
              />
              {errors?.infovehicule?.couleur && (
                <span className="error-msg">
                  {errors.infovehicule.couleur.message}
                </span>
              )}
              
          </label>
         
       </div>
        <div className='input-group'>
          <label className='obligatoire'>Date de Prémière mise en circulation
              <input type='date'
                name='dateMiseCirculation'
                max={new Date().toISOString().split('T')[0]}
                value={paiement.infovehicule.dateMiseCirculation || ''}
                {...register("dateMiseCirculation", {
                    required: "La date est obligatoire",
                    validate: {
                      notFuture: (value) => {
                        const today = new Date();
                        today.setHours(0, 0, 0, 0); // Reset time pour comparaison
                        const selectedDate = new Date(value);
                        return selectedDate <= today || "La date ne peut pas être dans le futur";
                      }
                    },
                    onChange: (e) => handleInput(e) // Votre gestionnaire existant
                })}
              />
              {errors?.dateMiseCirculation && (
                <span className="error-msg">
                    {errors.dateMiseCirculation.message}
                </span>
               )}
          </label>
          <label className='obligatoire'>Pays de provenance
              <select
                name="paysProvenance"
                value={paiement.infovehicule.paysProvenance || ""}
                {...register("paysProvenance", {
                    onChange: (e) => {
                       handleInput(e);
                    },
                  validate: (value) => value !== "" || "Ce champ est obligatoire.",
                })}
                >
                 <option value="">---</option>
               { pays.length > 0 && pays.map((pays,index) => (<option value={pays.nom } key={index}> { pays.nom }</option>)) }
              </select> 
              {errors.infovehicule?.paysProvenance && (
                 <span className="error-msg">{ errors.infovehicule.paysProvenance.message }</span>
              )}  
          </label>
        </div>
        <div className='input-group'> 
         <label className='obligatoire'>Pays de destination finale
              <select
                name="paysDestination"
                value={paiement.infovehicule?.paysDestination || ""}
                {...register("paysDestination", {
                    onChange: (e) => {
                       handleInput(e);
                    },
                    validate: {
                        required: value => value !== "" || "Ce champ est obligatoire",
                        differentFromOrigin: value => 
                          value !== paiement.infovehicule.paysProvenance || 
                          "Le pays de destination doit être différent du pays d'origine"
                      }
                  })}
                >
                 <option value="">---</option>
               { pays.length > 0 && pays.map((pays,index) => (<option value={pays.nom } key={index}> { pays.nom }</option>)) }
              </select> 
              {errors.infovehicule?.paysDestination && (
                 <span className="error-msg">{ errors.infovehicule.paysDestination.message }</span>
              )}  
         </label>
         <label></label>
        </div>
        
        <div className="buttons">
            <button className="secondary" onClick={prevStep}>
              Précedent
            </button>
            <button className="" type='submit'>
               Suivant
            </button>
         </div>
      </form>
    </div> 
  )
}

export default StepTwo
